import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import actionLoader from "store/modules/loader/loaderActions";
import { LOGIN, LOGOUT, LOGIN_WITH_TOKEN } from "services/Login";

const useAuth = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [loaderShowing, setShowLoader] = useState(false);
  const [userData, setUserData] = useState({
    jwtToken: null,
    userId: null,
    authenticated: false,
    nome: null,
    roles: null,
  });

  useEffect(() => {
    async function autoLogin() {
      const loginUserData = JSON.parse(localStorage.getItem("setstate_quiz"));
      if (loginUserData) {
        const data = JSON.stringify(loginUserData);
        localStorage.setItem("setstate_quiz", data);
      }

      setUserData(loginUserData);
    }
    autoLogin();
  }, []);

  async function handleLogin({ username, password, redirect }) {
    showLoader(true);

    const {
      value: { authenticated, nome, userId, roles ,error},
      jwtToken,
    } = await LOGIN({ username, password });

    localStorage.setItem(
      "setstate_quiz",
      JSON.stringify({
        jwtToken,
        userId,
        authenticated,
        nome,
        roles,
      })
    );
    localStorage.setItem("token", jwtToken);
    setUserData({
      jwtToken,
      userId,
      authenticated,
      nome,
      roles,
    });
    showLoader(false);
    if (authenticated === true) {
      navigate(redirect);
    }
    return {authenticated, error};
  }

  async function handleLogout() {
    showLoader(true);
    await LOGOUT();
    localStorage.removeItem("setstate_quiz");
    setUserData({
      jwtToken: null,
      userId: null,
      authenticated: false,
      nome: null,
      roles: null,
    });

    navigate("/login");
    showLoader(false);
  }

  async function loginWithToken(token) {
    showLoader(true);
    const {
      value: { authenticated, nome, userId, urlRedirect, error, roles },
      jwtToken,
    } = await LOGIN_WITH_TOKEN({ token: token });

    if (error?.length) {
      navigate("/");
      return;
    }

    setLocalStorage({
      jwtToken,
      userId,
      authenticated,
      nome,
      roles,
    });

    navigate(urlRedirect || "/");
    showLoader(false);
  }

  function setLocalStorage(user) {
    localStorage.setItem("setstate_quiz", JSON.stringify(user));
    localStorage.setItem("token", user.jwtToken);
    setUserData(user);
  }

  async function showLoader(value) {
    dispatch(actionLoader.showLoader(value));
    setShowLoader(value);
  }

  return {
    loaderShowing,
    showLoader,
    handleLogin,
    handleLogout,
    userData,
    setUserData,
    loginWithToken,
  };
};

export default useAuth;
